import React, { useEffect, useRef, useState, useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";

const OtpComponente = ({ name, id, onChange, isDesktop = false, setOptInput }) => {
  const digitosFirma = 6;
  const { updateToken } = useContext(AuthContext);

  const [otp, setOtp] = useState(new Array(digitosFirma).fill(""));
  const [activeOtpIndex, setActiveOtpIndex] = useState(0);
  const [currentOtpIndex, setCurrentOtpIndex] = useState(0);

  const inputRef = useRef(null);

  const handleOnChange = ({ target }) => {
    let { value } = target;

    // 🔹 SOLO NÚMEROS
    value = value.replace(/\D/g, "");

    const newOtp = [...otp];

    /* ================================
       🔥 MOBILE: OTP COMPLETO / PEGADO
    ================================= */
    if (value.length > 1) {
      const values = value.slice(0, digitosFirma).split("");

      values.forEach((v, i) => {
        newOtp[i] = v;
      });

      setOtp(newOtp);
      setActiveOtpIndex(values.length - 1);

      const otpString = newOtp.join("");
      updateToken(otpString);

      if (otpString.length === digitosFirma && onChange) {
        onChange({ target: { name, value: otpString } });
      }

      if (setOptInput) setOptInput(otpString);
      return;
    }

    /* ================================
       🔹 LÓGICA ORIGINAL (1 dígito)
    ================================= */
    newOtp[currentOtpIndex] = value.substring(value.length - 1);

    if (!value) setActiveOtpIndex(currentOtpIndex - 1);
    else setActiveOtpIndex(currentOtpIndex + 1);

    setOtp(newOtp);

    const otpString = newOtp.join("");
    updateToken(otpString);

    if (otpString.length === digitosFirma && onChange) {
      onChange({ target: { name, value: otpString } });
    }else{
      onChange({ target: { name, value: otpString } });
    }

    if (setOptInput) setOptInput(otpString);
  };

  const handleOnKeyDown = ({ key }, index) => {
    setCurrentOtpIndex(index);
    if (key === "Backspace") setActiveOtpIndex(index - 1);
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, [activeOtpIndex]);

  return otp.map((_, index) => (
    <React.Fragment key={index}>
      <input
        value={otp[index]}
        ref={index === activeOtpIndex ? inputRef : null}
        type="text" // 🔥 NO number
        inputMode="numeric" // teclado numérico
        autoComplete={index === 0 ? "one-time-code" : "off"}
        maxLength={index === 0 ? digitosFirma : 1}
        name={name}
        id={id}
        className="spin-button-none transition mx-0.4 lg:mx-1 text-lg py-1 w-10 text-center border-2 border-tdark/20 rounded-md focus:border-purple focus:ring-0"
        style={{
          height: "70px",
          width: "50px",
          fontSize: "33px",
          padding: "0px",
          borderRadius: "15px",
          backgroundColor: otp[index]
            ? isDesktop
              ? "#ECEBFF"
              : "#565584"
            : isDesktop
            ? "#2C2447"
            : "#2C2447",
          borderColor: otp[index]
            ? isDesktop
              ? "#7E02FC"
              : "#C9B8FF"
            : isDesktop
            ? "#C9B8FF"
            : "#565584",
          color: isDesktop ? "#7E02FC" : "#C9B8FF",
        }}
        onChange={handleOnChange}
        onKeyDown={(e) => handleOnKeyDown(e, index)}
      />
    </React.Fragment>
  ));
};

export default OtpComponente;
